import React, { Component } from 'react';
import CustomModal from '.';
import { showNotification } from '@mantine/notifications';
import GreenTick from '../../../../../assets/images/module/general/GreenTick.svg';
import { CopyValueIcon } from '../../../../../components/TransactionActionIcons';
import { Group, Stack, Tooltip } from '@mantine/core';
import PreviewField, { PreviewFieldGrid, PreviewSectionHeading, PREVIEW_FIELD_ROW_GAP, previewFieldValueStyle } from '../../../../../components/PreviewField';
import accounting from 'accounting';
import dayjs from 'dayjs';

const MOBILE_SIZE = 992;
const TABLET_SIZE = 1200;

export class TransactionDetailModal extends Component {
  state = {
    isMobile: window.innerWidth <= MOBILE_SIZE,
    isTablet: window.innerWidth <= TABLET_SIZE
  };

  constructor(props) {
    super(props);
  }

  copyIban = (iban) => {
    navigator.clipboard.writeText(iban);
    showNotification({
      message: 'Information kopiert.',
      icon: <img src={GreenTick} alt='green-tick'/>,
      id: 'dataCopied'
    });
  }

  render() {
    const { open, toggle, className, transaction, renderTransactionAssigmentBlock, isMobile } = this.props;

    return (
      <CustomModal
        heading={transaction?.counterpartName ? transaction?.counterpartName : '-'}
        headingClassName={'update-received-rent-modal-heading'}
        open={open}
        toggle={() => {
          toggle();
        }}
        className={`${className}`}
        //style={{maxWidth: '450px'}}
      >
        <Stack gap={0}>
            <PreviewSectionHeading>Transaktionsdaten</PreviewSectionHeading>
            <PreviewFieldGrid>
                <PreviewField label='Sender / Empfänger' value={transaction?.counterpartName} />
                <PreviewField label='Datum' value={transaction?.bankBookingDate && dayjs(transaction?.bankBookingDate).format('DD.MM.YYYY')} />
                <PreviewField label='Bankname' value={transaction?.counterpartBankName} />
                <PreviewField label='IBAN'>
                    {transaction?.counterpartIban ?
                    <Group gap={8} wrap='nowrap' align='center'>
                        <span style={{...previewFieldValueStyle, minWidth: 0}}>{transaction?.counterpartIban}</span>
                        <Tooltip label='IBAN kopieren' zIndex={99999} withArrow fz={12}>
                            <CopyValueIcon
                            size={16}
                            aria-label='IBAN kopieren'
                            style={{flexShrink: 0}}
                            onClick={()=> this.copyIban(transaction?.counterpartIban)}
                            />
                        </Tooltip>
                    </Group> : <span style={previewFieldValueStyle}>-</span>}
                </PreviewField>
                <PreviewField label='BIC' value={transaction?.counterpartBic} />
                <PreviewField label='Transaktionsart' value={transaction?.transactionType} />
                <PreviewField label='Betrag' value={accounting.formatMoney(transaction?.amount, '€', 2, '.', ',', '%v %s')} />
            </PreviewFieldGrid>
            <div style={{marginTop: PREVIEW_FIELD_ROW_GAP}}>
                <PreviewField label='Beschreibung' value={transaction?.purpose} />
            </div>
            {isMobile &&
            <div style={{marginTop: PREVIEW_FIELD_ROW_GAP}}>
                <PreviewField label='Ausgabe oder Miete erfassen'>
                    <span style={previewFieldValueStyle}>{renderTransactionAssigmentBlock()}</span>
                </PreviewField>
            </div>}
        </Stack>
      </CustomModal>
    );
  }
}

export default TransactionDetailModal;
